// Module
var code = `<style>:host{display:block;min-height:100px;min-width:100px;height:150px;width:150px}.wrapper{display:flex;flex-direction:column;height:100%;width:100%}</style> <div class="wrapper"></div>`;
// Exports
export default code;